import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/notifications/styles.css';
import React, { StrictMode } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import Signup from '~/src/pages/Signup';
import Feed from '~/src/pages/Feed';
import JoinRedirect from '~/src/pages/JoinRedirect';
import Signin from '~/src/pages/Signin';
import CheckEmail from '~/src/pages/CheckEmail';
import ForgotPassword from '~/src/pages/ForgotPassword';
import ResetPassword from '~/src/pages/ResetPassword';
import ColorPallete from '~/src/pages/ColorPallete';
import NotFound from '~/src/pages/NotFound';
import vars from '~/src/utils/global_css';
import CreatePost from '~/src/pages/CreatePost/index';
import { MantineProvider } from '@mantine/core';
import Onboarding from './pages/Onboarding';
import { Notifications } from '@mantine/notifications';
import GroupManagement from '~/src/pages/GroupManagement';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/feed" replace />,
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/check-email',
    element: <CheckEmail />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/feed',
    element: <Feed />,
  },
  {
    path: '/create-post',
    element: <CreatePost />,
  },
  {
    path: '/colors',
    element: <ColorPallete />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/onboarding',
    element: <Onboarding />,
  },
  {
    path: '/group-management',
    element: <GroupManagement />,
  },
  {
    path: '/join',
    element: <JoinRedirect />,
  },
]);

export default function App() {
  return (
    <StrictMode>
      <MantineProvider>
        <Notifications />
        <div id="react-root" style={vars}>
          <RouterProvider router={router} />
        </div>
      </MantineProvider>
    </StrictMode>
  );
}
